import React from 'react'
import { ArrowUpRight } from 'lucide-react'
import { Button, Card, CardContent } from '@/shared/ui'

type Props = {
  requiredPlanName?: string | null
  peopleCount?: number | null
}

export function AnalysisLockedCard({ requiredPlanName, peopleCount }: Props) {
  const planLabel = String(requiredPlanName || '').trim() || 'um plano superior'
  const showPeople = typeof peopleCount === 'number'
  const peopleLabel = showPeople ? `${peopleCount} pessoas estão conversando sobre ela nesse momento` : ''

  return (
    <Card className="relative overflow-hidden border-emerald-500/40 bg-gradient-to-r from-emerald-500/10 via-amber-500/10 to-lime-500/10">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/65" />
        <div className="absolute inset-0 p-4 md:p-5">
          <div className="h-full w-full rounded-2xl bg-background/30 p-4 md:p-5">
            <div className="h-full w-full space-y-4 opacity-50">
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-full bg-foreground/20" />
                <div className="flex-1 space-y-2">
                  <div className="h-3 w-2/3 rounded bg-foreground/20" />
                  <div className="h-2 w-1/3 rounded bg-foreground/10" />
                </div>
                <div className="h-6 w-6 rounded bg-foreground/10" />
              </div>
              <div className="space-y-2">
                <div className="h-3 w-full rounded bg-foreground/10" />
                <div className="h-3 w-5/6 rounded bg-foreground/10" />
                <div className="h-3 w-4/6 rounded bg-foreground/10" />
              </div>
              <div className="grid grid-cols-3 gap-2">
                <div className="h-14 rounded bg-foreground/10" />
                <div className="h-14 rounded bg-foreground/10" />
                <div className="h-14 rounded bg-foreground/10" />
              </div>
              <div className="flex items-center justify-between gap-3">
                <div className="h-3 w-24 rounded bg-foreground/10" />
                <div className="h-3 w-20 rounded bg-foreground/10" />
              </div>
              <div className="h-10 w-full rounded-xl bg-foreground/10" />
            </div>
          </div>
        </div>
      </div>

      <CardContent className="relative z-10 p-4 md:p-5">
        <div className="space-y-3">
          <div className="text-lg font-semibold text-emerald-300">
            Que pena, você ainda não tem acesso a essa análise!
          </div>
          <div className="text-sm text-foreground/80">
            Você poderia ter acesso a essa análise se o seu plano fosse {planLabel}.
          </div>
          {showPeople && (
            <div className="text-sm text-emerald-200">
              {peopleLabel}
            </div>
          )}
        </div>

        <div className="mt-4 rounded-xl border border-white/10 bg-zinc-900 p-4">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="max-w-[520px] text-base font-semibold leading-snug text-foreground md:text-lg">
              Não perca mais nenhuma análise e tenha acesso a mais moedas monitoradas pelo Cripto Alert!
            </div>
            <div className="flex justify-start md:justify-end">
              <Button
                type="button"
                onClick={() => { window.location.href = '/my-plans' }}
                className="inline-flex items-center gap-2 rounded-full bg-emerald-400 px-5 py-2 text-sm font-semibold text-black hover:bg-emerald-300"
              >
                Fazer Upgrade!
                <ArrowUpRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
